import React from 'react';
import LocationTemplate from './LocationTemplate';

const SelmaPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Selma"
      stateName="North Carolina"
      countyName="Johnston"
      zipCodes={["27576"]}
      latitude={35.5368}
      longitude={-78.2886}
      population={6913}
      historicalFact="Founded in 1867 around a railroad junction; name selected from a hat containing various suggestions."
      nearbyTowns={[
        "Smithfield, NC",
        "Clayton, NC",
        "Four Oaks, NC",
        "Kenly, NC",
        "Princeton, NC",
        "Wilson, NC",
        "Micro, NC",
        "Pine Level, NC"
      ]}
    />
  );
};

export default SelmaPage;